import { render, staticRenderFns } from "./AppDepartmentFactsBlock.vue?vue&type=template&id=400043a5"
import script from "./AppDepartmentFactsBlock.vue?vue&type=script&lang=js"
export * from "./AppDepartmentFactsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports